import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { CompanyBusinessSettings } from '@api/models/settings/CompanyBusinessSettings';
import { companySettingsService } from '@api/services/services';

type State = BaseType<CompanyBusinessSettings>;

const initialState: State = {
  state: FetchState.None,
  data: {
    maxEstablishments: undefined,
    maxUsers: undefined,
    maxTraining: undefined,
    passRisksEnabled: false,
    bannerUrl: '',
    primaryColor: '',
    secondaryColor: '',
    licenseValidFrom: '',
    licenseValidTo: '',
    applicationLanguages: [],
    testLanguages: [],
    defaultLanguage: '',
    turnstilesEnabled: false,
    allowEntryRequests: false,
    forTesting: false,
    allowAnalytics: false,
    allowSubcontractors: false,
  },
};

export const businessSettingsSlice = baseSlice({
  name: 'businessSettings',
  initialState,
});

export const selectBusinessSettingsState = (state: RootState) => state.businessSettings.state;
export const selectBusinessSettings = (state: RootState) => state.businessSettings.data;
export const businessSettingsActions = businessSettingsSlice.actions;

export const getBusinessSettings = () => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return companySettingsService.getBusinessSettings();
  };

  getItem({
    dispatch,
    actions: businessSettingsActions,
    getData: handleGetData,
  });
};
